import { useQuery } from '@tanstack/react-query';
import { listarAlertas } from '../lib/api/alertas';
import { qk } from './keys';

export function useAlertas() {
  return useQuery({ queryKey: qk.alertas, queryFn: listarAlertas });
}
